import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as ruptureActions from 'action/rupture'
import * as reportActions from 'action/report'
import ContentHeader from 'component/utils/ContentHeader'
import Rupture from 'component/report/rupture/OlderRupture'
import RuptureHeader from 'component/report/rupture/RuptureHeader'
import PeriodPickerRupture from 'component/report/rupture/PeriodPickerRupture'
import FeedbackError from 'component/utils/FeedbackError'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class OlderRuptureContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchRuptures: PropTypes.func.isRequired,
    fetchReports: PropTypes.func.isRequired,
    error: PropTypes.object,
    rupture: PropTypes.object,
    filters: PropTypes.object,
    auth: PropTypes.object.isRequired,
    missionsSelectBranchs: PropTypes.array,
    user: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.state = {
      showResults: false,
      missionsSelectBranchs: [],
      canSelectBranches: false
    }

    this.getCsv = this.getCsv.bind(this)
    this.getPdf = this.getPdf.bind(this)
    this.handleFetchRuptures = this.handleFetchRuptures.bind(this)
  }

  getCsv() {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 0,
    }

    fetchReports(user.dsToken, values, filters)
  }

  getPdf() {
    const {
      fetchReports,
      filters,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 1,
    }

    fetchReports(user.dsToken, values, filters)
  }

  handleFetchRuptures(values) {
    const { fetchRuptures, auth } = this.props

    this.setState({ showResults: true })

    fetchRuptures(auth, values)
  }

  renderError(message) {
    if (message.dsMessage) {
      const text = translate('form.data.invalid')

      return (
        <FeedbackError
          className='margin-top-double'
          message={message.dsMessage}
          text={text}
        />
      )
    }
  }

  componentDidMount() {
    const { auth } = this.props
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }

    this.getParameter(params).then(resp => {
      const missions = resp.data.split(",") || []
      const canSelectBranches = auth.user.locationCode === '999' || missions.includes(auth.user.title)
      this.setState({
        missionsSelectBranchs: missions,
        canSelectBranches
      })
    }).catch(() => {
      this.setState({ canSelectBranches: false })
    })
  }

  getParameter(values) {
    const { auth: { user } } = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
  }

  render() {
    const { translate, error, rupture, filters, auth } = this.props

    const { showResults } = this.state
    const hasResults = showResults && rupture

    if (hasResults) {
      return (
        <section>
          <ContentHeader>{translate('olderRuptures.title')}</ContentHeader>

          <RuptureHeader
            translate={translate}
            currentTitle={translate('olderRuptures.title')}
          />

          <Rupture
            missionsSelectBranchs={this.state.missionsSelectBranchs}
            translate={translate}
            rupture={rupture}
            getCsv={this.getCsv}
            getPdf={this.getPdf}
            filters={filters}
          />
        </section>
      )
    }

    return (
      <section>
        <ContentHeader>{translate('olderRuptures.title')}</ContentHeader>

        <RuptureHeader
          translate={translate}
          currentTitle={translate('olderRuptures.title')}
        />

        {error && this.renderError(error.message)}

        <PeriodPickerRupture
          translate={translate}
          missionsSelectBranchs={this.state.missionsSelectBranchs || []}
          fetchRuptures={this.handleFetchRuptures}
          auth={auth}
        />
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ ruptureReducer, reportReducer }) => ({
  rupture: ruptureReducer.record,
  error: ruptureReducer.error,
  filters: ruptureReducer.filters,
  report: reportReducer.get.record,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...ruptureActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
const RuptureTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(OlderRuptureContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(mapStateToProps, mapDispatchToProps)(RuptureTranslated)

/*
 * Exports as component
 */
export { OlderRuptureContainer }
